import React from "react";
import { useRouter } from "next/router";
import deliveryInformationDT from "../../data/content/delivery-information";
import DecisionTree from "../../components/decision-tree/DecisionTree";
import analyticsTrigger from "../../utils/analytics/trigger/analyticsTrigger";
import buildPathName from "../../utils/buildPathName";
import ESIPage from "@/components/esi-page/ESIPage";
import { capitalize } from "lodash";
import { isFeatureEnabled } from "@/utils/feature-flags";

function generateMetadata(params) {
  const title = params?.slug?.[0]?.split("-").map(capitalize).join(" ");
  return {
    title: title || "Delivery & Collection",
    description: `Find all the information you need regarding delivery and collection, including tracking your order, click and collect and our delivery services.`,
  };
}

const analyticsHandler = elements => {
  if (elements) {
    analyticsTrigger("dataStateChange", buildPathName(":delivery & collection", {}, elements), {}, "pageload");
  }
};

export const getServerSideProps = async ctx => {
  const showChristmanDeliveryScheduleButton = await isFeatureEnabled(ctx, "show_christmas_delivery_schedule_button");
  return {
    props: {
      showChristmanDeliveryScheduleButton,
    },
  };
};

function Page({ showChristmanDeliveryScheduleButton }) {
  const router = useRouter();
  if (router.query.slug) {
    return <ESIPage />;
  }
  const content = deliveryInformationDT({ showChristmanDeliveryScheduleButton });

  return (
    <DecisionTree
      content={content}
      startKey="deliveryOrCollection"
      defaultBackText="Delivery & Collection"
      onTreeUpdate={analyticsHandler}
    />
  );
}

Page.generateMetadata = generateMetadata;

export default Page;
